import HostedDesktopLayout from '../../../layouts/DesktopLayout';
import HostedActionRow from '../../../components/hosted/ActionRow';
import HostedWaitingScreen from '../shared/WaitingScreen';
import { useBackOrCancel } from '../../../hooks/useBackOrCancel';
import { type WaitingForPresentationPageProps } from '../../../chulak/ChulakSession';

export default function HostedDesktopWaitingPage({
  onCancel,
  onBack,
}: WaitingForPresentationPageProps) {
  const backOrCancel = useBackOrCancel(onCancel, onBack);

  return (
    <HostedDesktopLayout>
      <div className="flex flex-1 flex-col w-full">
        <div className="flex flex-1 items-center justify-center w-full">
          <div className="flex flex-col items-center gap-6 text-center max-w-lg w-full">
            <HostedWaitingScreen />

            <HostedActionRow
              className="my-6 w-full max-w-lg"
              secondary={backOrCancel}
            />
          </div>
        </div>
      </div>
    </HostedDesktopLayout>
  );
}
